var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('model-editor',{attrs:{"url":"/api/v1/job-board/locations","title":_vm.$t('title'),"type":_vm.$t('type'),"fields":_vm.rules,"columns":[{key: 'name', label: _vm.$t('field.name')}],"languages":_vm.languages,"sort":"name"}})}
var staticRenderFns = []

export { render, staticRenderFns }